import React from 'react';
import styles from './FormStep.css';

const Dot = function Dot(props) {
  const { active, current } = props;
  let className = 'progress-step';

  if (current) {
    className = 'progress-step-current';
  } else if (active) {
    className = 'progress-step-active';
  }
  return <div className={styles[className]} />;
};

Dot.defaultProps = {
  active: false,
  current: false,
};

export default Dot;
